import React, { FunctionComponent } from 'react'
import { useCheckoutState, useInlineArcadeComponentsEnabled, usePreferredCard } from '../../state'
import { MessageInline, MessageKinds } from '@afterpaytouch/core'
import { TrackOnMount } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { isUndefinedOrEmpty, valueIsNotNullOrUndefined } from '@afterpay/utils'
import { useCheckoutSizes } from '../../utils/responsive'

interface Props {
  message?: React.ReactNode
  testNamespace?: string
  kind?: MessageKinds
}

/** Generic Error Text component */

export const ErrorText: FunctionComponent<Props> = ({ message = '', testNamespace = '', kind = 'Error' }) => {
  const { card, reason } = usePreferredCard() ?? {}
  const { smallTextSize } = useCheckoutSizes()
  const { error } = useCheckoutState() ?? {}
  const testId = `${testNamespace.length > 0 ? `${testNamespace}-` : ''}error`
  const hasCardError = valueIsNotNullOrUndefined(card) && valueIsNotNullOrUndefined(reason)
  const shouldTrackNonTerminalError = valueIsNotNullOrUndefined(error) || hasCardError
  const isInlineArcadeComponentEnabled = useInlineArcadeComponentsEnabled()

  if (!message || (typeof message === 'string' && isUndefinedOrEmpty(message))) {
    return null
  }

  // When not in inline component mode, we always use the 'Error' kind
  const shouldUseErrorKind = !isInlineArcadeComponentEnabled || kind === 'Error'

  return (
    <>
      <MessageInline kind={shouldUseErrorKind ? 'Error' : 'Info'} description={message} descriptionSize={smallTextSize} testNameSpace={testId} />
      {shouldTrackNonTerminalError && (
        <TrackOnMount
          eventName={TrackingEvent.VIEWED_NON_TERMINAL_ERROR}
          eventProperties={{ ...(valueIsNotNullOrUndefined(error) && { errorCode: error?.error }), ...(hasCardError && { cardError: reason }) }}
        />
      )}
    </>
  )
}
